

















import Vue from 'vue';

import { getConfig } from '@/web/utils/configuration';

export default Vue.extend({
  name: 'HMMadeBy',
  computed: {
    config() {
      return getConfig();
    },
  },
});
